/// Firebase messaging is only needed when a standalone PWA asks for push.
/// Keep the SDK out of the shared homepage chunk.

const firebaseConfig = {
	apiKey: 'AIzaSyAdam32f-WqoF5ac8JRHhQLYfuiytQkCjU',
	authDomain: 'ordinals-wallet-8f5c7.firebaseapp.com',
	projectId: 'ordinals-wallet-8f5c7',
	storageBucket: 'ordinals-wallet-8f5c7.appspot.com',
	messagingSenderId: '58956925567',
	appId: '1:58956925567:web:95f794f262900148c10d4a',
	measurementId: 'G-XE6HRW50QJ',
	databaseURL: 'https://ordinals-wallet-8f5c7-default-rtdb.firebaseio.com/'
}

const VAPID_KEY =
	'BGLxBQiv0VBYMQ7r1WDO9jymplH6Tk1vMI9yc6V_f0gIU_xIjDdHEozGoFmLGb_udd24F646_j0CpS3-FpX8y6w'

export async function getFirebasePushToken(): Promise<string | null> {
	const { initializeApp, getApps } = await import('firebase/app')
	const { getMessaging, getToken } = await import('firebase/messaging')
	const app = getApps()[0] ?? initializeApp(firebaseConfig)
	return getToken(getMessaging(app), { vapidKey: VAPID_KEY })
}
